import { HomePageLinkType } from "../../products/models/ProductModel";
import { ProductUtils } from "../../products/ProductUtils";
import { ContextualMenuItem } from "../models/OtherTypes"

export type TopBranditemProps = {
    item: ContextualMenuItem;
}

export default function TopCategoryMenuView({ item }: TopBranditemProps) {
    let url = ProductUtils.getImageUrl(item.imageUrl);

    const onClick = () => {
        window.open(`/products?type=${HomePageLinkType.quickLink}&&key=${item.key}`, "_self");
    }

    return <div
        className="ph-10 pointer container border ml-5 mr-5 mt-5 mb-5"
        onClick={onClick} style={{ minWidth: 100, height: 40, display: "inline-flex", borderRadius: "30px" }}>
        <img src={url} alt={item.text} width={30} height={30} />
        <span className="font-smaller pl-5">{item.text}</span>
    </div>;
}